export default "__VITE_ASSET__rCcOQ7kq__"